import { FC } from "react"
import cn from "classnames"

import Text from "components/Text/Text"

interface IStatusTagProps {
    className: HTMLDivElement["className"]
    compact?: boolean
}

const StatusTag: FC<React.PropsWithChildren<IStatusTagProps>> = ({
    className,
    compact = false,
    children,
}) => {
    return <Text type="pSmallest" className={cn(
        "px-1 font-bold line-height-133p color-white round-sm d-inline-block text-center box-sizing-border-box",
        compact ? "py-quarter" : "py-half",
        className
    )}>
        {children}
    </Text>
}

export default StatusTag
